<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
<div >
    <v-subheader class="subtitle-1 whitesmoke font-weight-medium grayBold--text">
      {{ $t("device_info") }}
    </v-subheader>
      <HeatingControllerGeneralView v-if="device.info.device_type == 'DOMX_HC_OT'" :device="device"/>
      <IAQGeneralView v-else-if="device.info.device_type == 'DOMX_IAQ'" :device="device"/>
      <MBGeneralView v-else-if="device.info.device_type == 'DOMX_HC_MB'" :device="device"/>
      <SinglePhaseEnergyMeterGeneralView v-else-if="device.info.device_type == 'SHELLY_EM_1PH'" :device="device"/>
      <ThreePhaseEnergyMeterGeneralView v-else-if="device.info.device_type == 'SHELLY_EM_3PH'" :device="device"/>
</div>
</template>


<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'
import HeatingControllerGeneralView from './heating_controller_ot/HeatingControllerGeneralView.vue';
import IAQGeneralView from './iaq/IAQGeneralView.vue';
import MBGeneralView from './heating_controller_mb/MBGeneralView.vue';
import SinglePhaseEnergyMeterGeneralView from './energy_meter/SinglePhaseEnergyMeterGeneralView.vue';
import ThreePhaseEnergyMeterGeneralView from './energy_meter/ThreePhaseEnergyMeterGeneralView.vue';
import { devicesModule, installationsModule } from '@/store/modules/store-accessor';
@Component({
  components: {
    HeatingControllerGeneralView,
    IAQGeneralView,
    MBGeneralView,
    SinglePhaseEnergyMeterGeneralView,
    ThreePhaseEnergyMeterGeneralView
  }
})

export default class DevicesSideviewGeneralTab extends Vue {
 @Prop() device: Record<string, any>;
  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

};
</script>

<style scoped lang="scss">
.tab {
  max-height: calc(80vh) !important;
  overflow-y: auto;
}

div { 
    width:100%;
}
</style>
